// extracted by mini-css-extract-plugin
export default {"chatWrapper":"chatWrapper___V2STu","chatContainer":"chatContainer___JkSeI","messageContainer":"messageContainer___v6SB0"};